export default "/images/969cb850f15ce6f8528bb27d4f91e7c5.avif";